export const VIDFLEET_DMS_STATUS_REQUEST = "VIDFLEET_DMS_STATUS_REQUEST";
export const VIDFLEET_DMS_STATUS_RESULT = "VIDFLEET_DMS_STATUS_RESULT"; 